import { toneText } from "@/lib/statusTone";
import ReadMore from "@/components/ReadMore";

export type TestCoverage = { tests: number; total: number; tested: number; untested: { id: string; label: string }[] };

/**
 * How much of the plan this revision's tests reached; the person decides
 * whether that is enough. One plain sentence; the steps no test reached,
 * with their ids, sit under Read more.
 * See docs/superpowers/specs/2026-10-14-plain-words-read-more-design.md.
 */
export default function TestCoverageLine({ coverage, inline = false }: { coverage: TestCoverage | null | undefined; /** Inside a paragraph (the approval control in a reply): spans and a button instead of a details element. */ inline?: boolean }) {
  if (!coverage || coverage.tests === 0 || coverage.total === 0) return null;
  return <span className="mb-2 block">
    <span className={coverage.untested.length ? toneText.attention : "text-zinc-400"}>
      The tests covered {coverage.tested} of the {coverage.total} steps.
    </span>
    {coverage.untested.length > 0 && <ReadMore className="mt-1" inline={inline}>
      <span className="block">Not reached by any test:</span>
      {coverage.untested.map((step) => <span className="block" key={step.id}>{step.label} ({step.id})</span>)}
    </ReadMore>}
  </span>;
}
